import {
  FETCH_VOTES,
  FETCH_VOTES_FAILURE,
  FETCH_VOTES_SUCCESS,
} from "./constants";

export const fetchVotes = (payload) => ({
  type: FETCH_VOTES,
  payload,
});
export const fetchVotesSuccess = (payload) => ({
  type: FETCH_VOTES_SUCCESS,
  payload,
});
export const fetchVotesFailure = (payload) => ({
  type: FETCH_VOTES_FAILURE,
  payload,
});
